import { useTheme } from "@mui/material"
import { Track } from "../../../interfaces/dtos/track"
import { TrackListDeleteConfirmationItem } from "./TrackListDeleteConfirmationItem";

interface TrackListDeleteConfirmationProps {
    tracks: Track[]
}

export const TrackListDeleteConfirmation = ({
    tracks
}: TrackListDeleteConfirmationProps) => {

    const theme = useTheme();

    return (
        <>
            You are about to 
            <span style={{color:theme.palette.error.main, fontWeight:'bold'}}> delete </span> 
            the following track{tracks.length === 1 ? '' : 's'}:<br />
            Do you wish to proceed?
            <ul>
                {tracks.map((t) => (
                    <li key={t.key}>
                        <TrackListDeleteConfirmationItem track={t} />
                    </li>
                ))}
            </ul>
        </>
    )
}
